{
  "iframeWaitingMessage": "感謝您等待，請再稍候片刻...",
  "otherOrganizations": "其他組織",
  "solutionIframe": "主要內容",
  "unloadPromptMessage": "您確定嗎?"
}
